import {sameLine} from './approval-line-identity';

// Keep the preview independent of the draft: closing the amount editor must
// discard its temporary changes without changing what Save will persist.
export function buildApprovalPolicyPreview(json = {}, expenseItem = null, receiptTotalEdits = {}, expenseItemIndex = null) {
    const preview = JSON.parse(JSON.stringify(json));
    const edits = {...receiptTotalEdits};
    if (expenseItem) {
        const subtotal = Number(expenseItem.amounts_summary?.ItemSubTotal);
        const tip = Number(expenseItem.amounts_summary?.TipAllocatedToItem);
        const original = preview.ListItem?.find((item, i) => sameLine(item, i, expenseItem, expenseItemIndex));
        const amountChanged = original && (subtotal !== Number(original.amounts_summary?.ItemSubTotal ?? original.SubTotal ?? original.Total)
            || tip !== Number(original.amounts_summary?.TipAllocatedToItem ?? original.TipAllocated ?? 0));
        if (amountChanged) {
            // The backend derives the new whole-receipt total, including sibling shares.
            delete edits[expenseItem.checksum];
        }
        preview.ListItem = (preview.ListItem || []).map((item, i) => sameLine(item, i, expenseItem, expenseItemIndex)
            ? {...expenseItem, ...(amountChanged ? {SubTotal: subtotal, TipAllocated: tip, Total: subtotal + tip} : {})}
            : item);
    }
    return {json: preview, receipt_total_edits: edits, calculate_taxes: Boolean(expenseItem)};
}

// Only these inputs can change the current expense policies. Descriptions,
// comments and accounting codes should not cause another policy request.
export function approvalPolicyPreviewKey(payload) {
    return JSON.stringify({
        receipts: payload.receipt_total_edits,
        items: (payload.json.ListItem || []).map(item => ({
            id: item._view_id, checksum: item.checksum,
            subtotal: Number(item.amounts_summary?.ItemSubTotal ?? item.SubTotal ?? item.Total ?? 0),
            tip: Number(item.amounts_summary?.TipAllocatedToItem ?? item.TipAllocated ?? 0),
            taxCode: item.TaxCode, billable: item.IsBillable,
        })),
    });
}
